import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants';
import { useSearch } from 'src/hooks';
import { listTasksPromise, ListTasksPromiseParams } from 'src/utils';

export type UseListTasksParams = {
  filterParams?: ListTasksPromiseParams['filterParams'];
};

export const useListTasks = (params?: UseListTasksParams) => {
  const [searchParams] = useSearch();

  const filterParams = params?.filterParams || {
    task_status: searchParams?.task_status,
    task_type: searchParams?.task_type,
    search: searchParams?.search,
    view_all_users: searchParams?.view_all_users,
    pageNumber: Number(searchParams?.page) || 1,
  };

  const { data, isLoading, error, isRefetching } = useQuery({
    queryKey: [QUERY_KEY_MAP.useListTasks, filterParams],
    queryFn: ({ signal }) => listTasksPromise({ signal, filterParams }),
    refetchInterval: 20000, // 20 seconds  milliseconds
  });

  return {
    data,
    isLoading,
    error,
    isRefetching,
  };
};
